import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "fs-5 text-gray-700 mb-8" }, " TekPanel ile ilgili her türlü soru, görüş ve teknik destek talebiniz için bize aşağıdaki kanaldan ulaşabilirsiniz. Mesajlarınıza en kısa sürede dönüş yapıyoruz. ", -1)
const _hoisted_2 = { class: "row g-5 mb-10" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = { class: "border rounded p-6 h-100" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-dark fs-5 mb-2" }, "E-posta", -1)
const _hoisted_6 = { class: "text-primary fw-semibold fs-5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500 fs-7 mt-2" }, " Genel sorular ve teknik destek ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "border rounded p-6 h-100" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-dark fs-5 mb-2" }, "Çalışma saatleri"),
    /*#__PURE__*/_createElementVNode("div", { class: "text-gray-700 fs-6" }, "Hafta içi 09:00 – 18:00"),
    /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500 fs-7 mt-2" }, " Mesai dışında gelen talepler ertesi iş günü yanıtlanır. ")
  ])
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold text-dark mb-4" }, "Sık sorulan sorular", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-dark fs-6" }, "Nasıl giriş yaparım?"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-6" }, " Mevcut TekPanel hesabınızın telefon numarası ve şifresiyle giriş yapabilirsiniz. ")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-dark fs-6" }, "Şifremi unuttum, ne yapmalıyım?"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-6" }, " Giriş ekranındaki \"Şifremi unuttum\" adımını izleyin; doğrulama kodu telefonunuza gönderilir. ")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-dark fs-6" }, " Yeni bir platform hesabı nasıl bağlarım? "),
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-6" }, " Giriş yaptıktan sonra \"Entegrasyon Ekle\" bölümünden ilgili platformun hesap bilgileriyle bağlantı kurabilirsiniz. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PublicPage = _resolveComponent("PublicPage")!

  return (_openBlock(), _createBlock(_component_PublicPage, {
    title: "Destek & İletişim",
    subtitle: "Size yardımcı olmaktan memnuniyet duyarız."
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.emailUser) + " ( at ) " + _toDisplayString(_ctx.emailDomain), 1),
            _hoisted_7,
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-light-primary mt-3",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyEmail && _ctx.copyEmail(...args)))
            }, _toDisplayString(_ctx.copied ? "Kopyalandı ✓" : "Adresi kopyala"), 1)
          ])
        ]),
        _hoisted_8
      ]),
      _hoisted_9,
      _hoisted_10,
      _hoisted_11,
      _hoisted_12
    ]),
    _: 1
  }))
}